import type { LocaleDictionary } from "@/i18n/types";

const nsSheetEN = {
  fallbackName: "sheet",
  row: {
    downloadCSV: "Download (CSV)",
    downloadReferencedCSV: "Download Referenced Data (CSV)",
    uploadCSV: "Upload (CSV)",
    uploadTadsData: "Upload (CSV/JSON)",
    downloadTadsJSON: "Download (JSON)",
    uploadOverwrite: "Overwrite",
    uploadAppend: "Add",
    duplicate: "Duplicate Sheet",
    delete: "Delete Sheet",
  },
  menu: {
    create: "Create Sheet",
    downloadExcel: "Download All Data (Excel)",
    downloadJSON: "Download All Data (JSON)",
    downloadYAML: "Download Sheet Configs (YAML)",
    uploadData: "Bulk Upload",
    openList: "Open Sheet List",
  },
  dataDownload: {
    inProgress: "Downloading data...",
    success: "Data downloaded.",
    error: "Failed to download data.",
  },
  schemaDownload: {
    inProgress: "Downloading sheet config files...",
    success: "Sheet config files downloaded.",
    error: "Failed to download sheet config files.",
  },
  csv: {
    invalidSheetError: "Sheet data is invalid and cannot be downloaded.",
    downloadSuccess: "Download complete.",
    downloadError: "An error occurred while downloading.",
    noFileError: "No file selected.",
    uploadSuccess: "CSV data uploaded.",
    uploadError: "Failed to upload CSV data.",
  },
  tadsReplaceDialog: {
    title: "Replace Range of Time-Accumulated Data Sheet",
    message: ({ fileName, window }: { fileName: string; window: string }) =>
      `All existing rows in ${window} will be deleted and replaced with the contents of "${fileName}".`,
    unresolvableWindow:
      'Cannot replace rows because the reference period of this sheet cannot be resolved. Fix the reference period from "Reference range" in the sheet settings.',
    button: "Replace",
    inProgressButton: "Replacing...",
    inProgressTitle: "Replacing rows...",
    success: ({ importedRows }: { importedRows: number }) =>
      `Replaced with ${importedRows} rows.`,
    error: "Failed to replace rows.",
  },
  tadsAppend: {
    inProgressTitle: "Adding rows...",
    unsupportedFile: "Select a CSV or JSON file.",
    unresolvableWindow:
      'Cannot add rows because the reference period of this sheet cannot be resolved. Fix the reference period from "Reference range" in the sheet settings.',
    success: ({ importedRows }: { importedRows: number }) =>
      `Added ${importedRows} rows.`,
    error: "Failed to add rows.",
  },
  referencedSheetsCheckError: "Failed to check sheet references.",
  duplicate: {
    inProgress: "Duplicating sheet...",
    success: "Sheet duplicated.",
    error: "Failed to duplicate sheet.",
  },
  uploadDialog: {
    title: "Upload Sheet Data (Excel, CSV, JSON)",
    button: "Update All",
    description: "This will update the data.",
    selectFile: "Select a data file to update.",
    connectCSV: "Map CSV data to a sheet.",
    saveTypeLabel: "Upload Method",
    saveTypeOverwrite: "Overwrite",
    saveTypeAppend: "Add",
    noteExcel:
      "Sheets not included in the Excel file and referenced sheets will remain unchanged.",
    noteJSON:
      "Sheets not included in the JSON file and referenced sheets will remain unchanged.",
    noteCSV: "For CSV files, only the selected sheet will be updated.",
    inProgressTitle: "Uploading data...",
    csvInProgressTitle: "Uploading CSV data...",
  },
  deleteDialog: {
    title: "Delete Sheet",
    message: ({ sheetName }: { sheetName: string }) =>
      `"${sheetName}" will be deleted. This action cannot be undone.`,
    referencedWarning:
      "This sheet is referenced by other sheets, which may cause display issues.",
    button: "Delete",
    inProgressButton: "Deleting...",
    success: "Sheet deleted.",
    error: "Failed to delete sheet.",
  },
} satisfies LocaleDictionary;

export default nsSheetEN;
